module.exports = __webpack_public_path__ + "static/img/artist-stef-banner@2x.742fd4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-stef-banner@2x.png
// module id = /h9h
// module chunks = 13